import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ApiStatus } from "../../utils/api.types";
import {
  fetchBarcodePatterns,
  createBarcodePattern,
  updateBarcodePattern,
  deleteBarcodePattern,
} from "./barcodePatternThunk";

interface BarcodePatternSliceState {
  patterns: any[];
  status: ApiStatus;
  errorMessage?: string;
}

const initialState: BarcodePatternSliceState = { patterns: [], status: ApiStatus.IDLE, errorMessage: "" };

const barcodePatternSlice = createSlice({
  name: "barcodePattern",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBarcodePatterns.pending, (state) => { state.status = ApiStatus.LOADING; })
      .addCase(fetchBarcodePatterns.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        state.patterns = Array.isArray(action.payload) ? action.payload : action.payload?.data || [];
      })
      .addCase(fetchBarcodePatterns.rejected, (state, action) => { state.status = ApiStatus.FAILED; state.errorMessage = action.error.message; })

      .addCase(createBarcodePattern.fulfilled, () => { toast.success("Barcode pattern saved"); })
      .addCase(createBarcodePattern.rejected, (state, action) => { toast.error(action.error.message || "Failed to save pattern"); })

      .addCase(updateBarcodePattern.fulfilled, () => { toast.success("Barcode pattern updated"); })
      .addCase(updateBarcodePattern.rejected, (state, action) => { toast.error(action.error.message || "Failed to update pattern"); })

      .addCase(deleteBarcodePattern.fulfilled, () => { toast.success("Barcode pattern removed"); })
      .addCase(deleteBarcodePattern.rejected, (state, action) => { toast.error(action.error.message || "Failed to remove pattern"); });
  },
});

export default barcodePatternSlice.reducer;
